import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Button } from "../ui/button";
import { LogOut, LifeBuoy } from "lucide-react";

export const Header = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header
      className="sticky top-0 z-50 border-b backdrop-blur-xl"
      style={{
        backgroundColor: "rgba(253, 251, 247, 0.8)",
        borderColor: "var(--border)",
      }}
      data-testid="app-header"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <Link
          to={user ? "/dashboard" : "/"}
          className="flex items-center gap-2"
          data-testid="header-logo"
        >
          <div
            className="w-9 h-9 rounded-full flex items-center justify-center"
            style={{ backgroundColor: "var(--surface-2)" }}
          >
            <LifeBuoy className="w-4 h-4" style={{ color: "var(--terracotta)" }} />
          </div>
          <span className="font-serif text-2xl tracking-tight" style={{ color: "var(--ink)" }}>
            Anchor
          </span>
        </Link>

        <nav className="flex items-center gap-3">
          {user ? (
            <>
              <span
                className="hidden md:block text-sm"
                style={{ color: "var(--ink-soft)" }}
                data-testid="header-user-name"
              >
                Hi, {user.name.split(" ")[0]}
              </span>
              <Button
                variant="ghost"
                onClick={() => {
                  logout();
                  navigate("/");
                }}
                className="rounded-full"
                data-testid="logout-btn"
              >
                <LogOut className="w-4 h-4 mr-2" /> Sign out
              </Button>
            </>
          ) : (
            <>
              <Button
                variant="ghost"
                onClick={() => navigate("/auth?mode=login")}
                className="rounded-full"
                data-testid="header-login-btn"
              >
                Sign in
              </Button>
              <Button
                onClick={() => navigate("/auth?mode=signup")}
                className="rounded-full text-white"
                style={{ backgroundColor: "var(--terracotta)" }}
                data-testid="header-signup-btn"
              >
                Begin
              </Button>
            </>
          )}
        </nav>
      </div>
    </header>
  );
};
